
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { RefreshCw, CheckCircle, AlertCircle } from "lucide-react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";

interface CampaignStatusUpdaterProps {
  onStatusUpdate?: () => void;
}

export const CampaignStatusUpdater: React.FC<CampaignStatusUpdaterProps> = ({ onStatusUpdate }) => {
  const [isUpdating, setIsUpdating] = useState(false);

  const handleUpdateCampaignStatus = async () => {
    setIsUpdating(true);
    
    try {
      
      // Chamar a edge function para atualizar status das campanhas
      const { data, error } = await supabase.functions.invoke('campaign-status-updater', {
        method: 'POST',
        body: { manual: true }
      });

      if (error) {
        toast.error("Erro ao verificar campanhas", {
          description: error.message || "Falha na comunicação com o servidor"
        });
        return;
      }

      if (data?.success) {
        toast.success("Verificação concluída!", {
          description: data.message || "Status das campanhas atualizado com sucesso",
          icon: <CheckCircle className="h-4 w-4" />
        });
        
        // Chamar callback para atualizar a lista de campanhas
        if (onStatusUpdate) {
          onStatusUpdate();
        }
      } else {
        toast.error("Falha na verificação", {
          description: data?.error || "Erro desconhecido durante a verificação",
          icon: <AlertCircle className="h-4 w-4" />
        });
      }

    } catch (error) {
      toast.error("Erro na verificação", {
        description: "Falha ao executar verificação das campanhas"
      });
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <Button
      onClick={handleUpdateCampaignStatus}
      disabled={isUpdating}
      variant="outline"
      size="sm"
      className="flex items-center gap-2"
    >
      <RefreshCw className={`h-4 w-4 ${isUpdating ? 'animate-spin' : ''}`} />
      {isUpdating ? 'Verificando...' : 'Verificar Campanhas'}
    </Button>
  );
};
